// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qV0XY","button":"Pagination_button__cyw3T"};